export default function typedKeys<T>(v: T) {
	return Object.keys(v) as Array<keyof typeof v>
}
